import React, { useState } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

const UploadFile = (props) => {
  const hiddenFileInput = React.useRef(null);
  const [file, setFile] = useState();
  const [fileB64, setFileB64] = useState();
  const [openPreview, setOpenPreview] = useState(false);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleChange = async (event) => {
    const fileUploaded = event.target.files[0];

    if (!fileUploaded) {
      props.setErrorMessage(true);
      return;
    }

    if (props.typeFile.includes(fileUploaded.type)) {
      setFile(fileUploaded);
      if (props.handleFileUploaded) {
        props.handleFileUploaded(fileUploaded);
      }
      const base64File = await getBase64(fileUploaded);
      setFileB64(base64File);
      props.handleFile(base64File);
      if (props.nameFile) props.nameFile(fileUploaded.name);
      props.setErrorMessage(false);
    } else {
      props.setErrorMessage(true);
    }
  };

  const clearFile = () => {
    setFile(null);
    setFileB64(null);
    props.handleFile(null);
    if (props.handleFileUploaded) {
      props.handleFileUploaded(null);
    }
  };
  return (
    <>
      {!file && (
        <div style={{ cursor: "pointer" }} onClick={handleClick}>
          <form method="post" action="" encType="multipart/form-data">
            <ul className="upload-pictures-wall">
              <li>
                <input
                  ref={hiddenFileInput}
                  onChange={handleChange}
                  style={{ display: "none" }}
                  type="file"
                  name="upload5"
                  id="upload5"
                  className="upload pictures-wall"
                  multiple={false}
                  accept=".pdf,.jpeg,.jpg,.png,.csv,application/vnd.ms-excel,text/csv"
                />
                <label>
                  <svg className="icon icon-sm" aria-hidden="true">
                    <use href={`${iconSprite}#it-plus`} />
                  </svg>
                  <span>Carica file</span>
                </label>
                <p
                  className="text-muted mb-0 ml-1"
                  style={{ fontSize: "0.9em" }}
                >
                  {!props.typeFile.includes("text/csv") ? (
                    <>(In pdf, jpeg o jpg)</>
                  ) : (
                    <>(In formato csv)</>
                  )}
                </p>
              </li>
            </ul>
          </form>
        </div>
      )}

      {file && (
        <div className="upload-dragdrop-text w-100">
          <p className="upload-dragdrop-weight">
            <svg className="icon icon-primary icon-xs">
              <use href={`${iconSprite}#it-file`} />
            </svg>
          </p>

          <div className="row mb-3">
            <div className="col-7">
              <h5>
                <svg
                  className="icon icon-primary"
                  onClick={clearFile}
                  style={{ cursor: "pointer" }}
                >
                  <use xlinkHref={`${iconSprite}#it-file`}></use>
                </svg>
                <a>{file.name}</a>
              </h5>
            </div>

            <div className="col-3 text-right">
              {!props.typeFile.includes("text/csv") && (
                <button
                  className="btn btn-outline-primary"
                  onClick={() => setOpenPreview(!openPreview)}
                  title="Visualizza"
                  style={{
                    color: "blue",
                    backgroundColor: "transparent",
                    border: "none",
                    borderBlockColor: "blue",
                  }}
                >
                  <svg className="icon icon-primary">
                    <use xlinkHref={`${iconSprite}#it-search`}></use>
                  </svg>
                </button>
              )}
            </div>

            <div className="col-1 text-right">
              <button
                className="btn btn-outline-danger"
                onClick={clearFile}
                title="Elimina"
                style={{
                  color: "red",
                  backgroundColor: "transparent",
                  border: "none",
                }}
              >
                <svg className="icon icon-danger">
                  <use xlinkHref={`${iconSprite}#it-close`}></use>
                </svg>
              </button>
            </div>
          </div>

          <div className="row ml-1">
            <div className="col-6">
              <h6 className="text">
                <svg className="icon icon-success">
                  <use xlinkHref={`${iconSprite}#it-check`}></use>
                </svg>
                {props.testoCaricamento
                  ? props.testoCaricamento
                  : "Il file è stato caricato correttamente!"}
              </h6>
            </div>
          </div>
        </div>
      )}

      {openPreview && fileB64 && (
        <div>
          <object
            className="mt-5"
            width="100%"
            height="900"
            data={fileB64}
            type="application/pdf"
          ></object>
        </div>
      )}
    </>
  );
};

export default UploadFile;
